import React, { Fragment } from 'react';
import '../../driverFaq.css';

const WalkingAccess = () => (
  <Fragment>
    <p>
      Enter 3 Embarcadero Center and walk to the dedicated parking
      elevators on the north side. Take either of the two parking elevators
      to parking level A and follow the Autzu signage to find the Autzu EVs
    </p>
    <br />
  </Fragment>
);

export default WalkingAccess;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Embarcadero/WalkingAccess.js